// extracted by mini-css-extract-plugin
module.exports = {"container":"CommentRibbon_container__2GO0q","slideNameStyle":"CommentRibbon_slideNameStyle__14DuB"};